import { ADMIN_API_URL } from "../Admin";

export const BOOKINGS_ADMIN_BASE_URL = `${ADMIN_API_URL}bookings/resource/`;

export const ARCHIVE_CONFIRM_MESSAGE = 'Are you sure you want to archive this category?';
export const ARCHIVE_WARNING_MESSAGE = 'There are {COUNT} active bookings associated with this category, archiving it will cancel the bookings(s).\nThis might take a long time with many bookings! Please do not navigate away from this page.\n Are you sure you want to proceed?';

export const DEACTIVATE_AMENITY_CONFIRM_MESSAGE = 'Are you sure you want to deactivate this amenity?';
export const DEACTIVATE_AMENITY_WARNING_MESSAGE = 'There are {COUNT} active bookings associated with this amenity, deactivating it will cancel the bookings(s). Are you sure you want to proceed?';

export const ARCHIVE_AMENITY_CONFIRM_MESSAGE = 'Are you sure you want to delete this amenity?';
export const ARCHIVE_AMENITY_WARNING_MESSAGE = 'There are {COUNT} active bookings associated with this amenity, deleting it will cancel the bookings(s). Are you sure you want to proceed?';

export const defaultCategoryColumns = [
    {
        type: 'default',
        value: 'default|reference',
        label: 'Booking Reference',
    },
    {
        type: 'default',
        value: 'default|timeslot',
        label: 'Time',
    },
    {
        type: 'default',
        value: 'default|name',
        label: 'Name',
    },
    {
        type: 'default',
        value: 'default|amenity',
        label: 'Booked Amenity',
    },
];
